import React from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const applyFormats = (worksheet, formats) => {
  if (!worksheet["!ref"]) return;

  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  // First row contains the column headers
  for (let col = range.s.c; col <= range.e.c; col++) {
    const headerAddress = XLSX.utils.encode_cell({
      r: 0,
      c: col,
    });

    const headerCell = worksheet[headerAddress];

    if (!headerCell) continue;

    const columnName = String(headerCell.v);

    if (!formats[columnName]) continue;

    for (let row = 1; row <= range.e.r; row++) {
      const cellAddress = XLSX.utils.encode_cell({
        r: row,
        c: col,
      });

      const cell = worksheet[cellAddress];

      if (cell) {
        cell.z = formats[columnName];
      }
    }
  }
};

export const JsonToExcelFormatted = ({
  data,
  title,
  fileName,
  btnClassName,
  btnColor = "#4CAF50",
  multipleSheets,
  formats = {},
}) => {
  const downloadExcel = () => {
    const workbook = {
      Sheets: {},
      SheetNames: [],
    };

    if (multipleSheets) {
      data.forEach(({ sheetName, details }) => {
        const worksheet = XLSX.utils.json_to_sheet(details);

        applyFormats(worksheet, formats);

        workbook.Sheets[sheetName] = worksheet;
        workbook.SheetNames.push(sheetName);
      });
    } else {
      const worksheet = XLSX.utils.json_to_sheet(data);

      applyFormats(worksheet, formats);

      workbook.Sheets.data = worksheet;
      workbook.SheetNames.push("data");
    }

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <div>
      <button
        className={`${btnClassName || ""} download-button`}
        onClick={downloadExcel}
        style={{ background: btnColor }}
      >
        {title || "Download"}
      </button>
    </div>
  );
};
